<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/account' }">账号管理</el-breadcrumb-item>
      <el-breadcrumb-item>添加账号</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div  slot="header" class="flexContainer">
        <span  class="cardHeader">添加账号</span>
      </div>

      <el-form :model="form" ref="formRef" :rules="formRules" label-width="100px" :inline="false" size="normal" style="max-width:500px">
        <el-form-item label="账号：" prop="account">
          <el-input v-model="form.account" placeholder="2-15个字符"></el-input>
        </el-form-item>
        <el-form-item label="使用人：" prop="name">
          <el-input v-model="form.name" placeholder="使用者姓名"></el-input>
        </el-form-item>
        <el-form-item label="登录密码：" prop="password">
          <el-input v-model="form.password" placeholder="5-15个字符" show-password></el-input>
        </el-form-item>
        <el-form-item label="重输密码：" prop="repassword">
          <el-input v-model="form.repassword" placeholder="重新输入密码" show-password></el-input>
        </el-form-item>

        <el-form-item label="可用角色：" prop="roleIds">
          <el-checkbox-group v-model="form.roleIds">
            <template v-for="item in roleList">
              <el-checkbox :label="item._id" :key="item._id">
                {{item.name}}
              </el-checkbox>
              <div :key="'div'+item._id" style="color:#aaaaaa;font-size:10px;margin-top:-15px">说明：{{item.desc}}</div>
            </template>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="okClickHandler">添加账号</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>

    </el-card>

  </div>
</template>

<script>
export default {
  data () {
    const checkRePws = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一样'))
      } else {
        callback()
      }
    }
    return {
      form: {
        account: '',
        password: '',
        repassword: '',
        name: '',
        roleIds: []
      },
      roleList: [],

      formRules: {
        account: [
          { type: 'string', required: true, message: '请输入账号', trigger: 'blur' },
          { type: 'string', min: 2, max: 15, message: '账号必须为2-15位', trigger: 'blur' },
          { type: 'string', pattern: /^[a-z0-9]+$/, message: '账号必须是小写字母和数字的组合', trigger: 'blur' }
        ],
        password: [
          { type: 'string', required: true, message: '请设置密码', trigger: 'blur' },
          { min: 5, max: 15, message: '密码长度应为5-15位', trigger: 'blur' }
        ],
        repassword: {
          required: true, validator: checkRePws, trigger: 'blur'
        },
        name: [
          { type: 'string', required: true, message: '请账号使用人姓名', trigger: 'blur' },
          { min: 2, max: 15, message: '使用人姓名必须为2-15位', trigger: 'blur' }
        ],
        roleIds: { type: 'array', min: 1, required: true, message: '请选择至少选择1个角色', trigger: 'change' }

      }
    }
  },
  created () {
    this.getRoleList()
  },
  methods: {
    // 取得角色列表
    async getRoleList () {
      const { data: res } = await this.$http.get('account/roleList')
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }
      this.roleList = res.data
      console.log(this.roleList)
    },

    // 点击添加按钮
    async okClickHandler () {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false
        const { data: res } = await this.$http.post('account/add', this.form)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(res.meta.msg)
        this.goBack()
      })
    },

    // 返回
    async goBack () {
      this.$router.push('/account')
    }
  }
}
</script>

<style lang="less" scoped>

</style>
